import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Navigation, Params, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard  {

    constructor(
        protected myRouter: Router,
        protected myAuthenticationService: AuthenticationService,
    ) {
    }

    public canLoad(route: Route, _segments: UrlSegment[]): Observable<boolean | UrlTree>  {
        const queryParams: Params = this.myRouter.getCurrentNavigation().extractedUrl.queryParams;
        const token: string = queryParams[ 'loginToken' ] || queryParams[ 'shared' ] ? document.cookie.match('(^|;)\\s*loginToken\\s*=\\s*([^;]+)')?.pop() : null;
        if (token) {
            return from(this.myAuthenticationService.setToken(token)).pipe(map(() => {
                delete queryParams[ 'loginToken' ];
                delete queryParams[ 'shared' ];
                return this.myRouter.createUrlTree([ route.path ], { queryParams: { ...queryParams } });
            }));
        } else {
            return this.myAuthenticationService.isLoginValid().pipe(tap((valid: boolean) => {
                if (!valid) {
                    const navigation: Navigation = this.myRouter.getCurrentNavigation();
                    let url: string = '/';
                    if (navigation) {
                        url = navigation.extractedUrl.toString();
                    }
                    void this.myRouter.navigate([ '/login' ], { queryParams: { return: url } });
                }
            }));
        }
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const queryParams: Params = this.myRouter.getCurrentNavigation().extractedUrl.queryParams;
        const token: string = queryParams[ 'loginToken' ] || queryParams[ 'shared' ] ? document.cookie.match('(^|;)\\s*loginToken\\s*=\\s*([^;]+)')?.pop() : null;
        if (token) {
            return from(this.myAuthenticationService.setToken(token)).pipe(map(() => {
                delete queryParams[ 'loginToken' ];
                delete queryParams[ 'shared' ];
                return this.myRouter.createUrlTree([ route.routeConfig.path ], { queryParams: { ...queryParams } });
            }));
        } else {
            const roles: string[] = route.data ? route.data[ 'roles' ] as string[] : null;

            return this.myAuthenticationService.isLoginValid().pipe(
                map((valid: boolean) => {
                    if (!valid) {
                        return this.myRouter.createUrlTree([ '/login' ], { queryParams: { return: state.url } });
                    }
                    if (!this.myAuthenticationService.userHasRoles(roles)) {
                        return this.myRouter.parseUrl('/landing');
                    }
                    return valid;
                }),
            );
        }
    }

}
